/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import Button from '@tcp/core/src/components/common/atoms/Button';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import TextItems from '@tcp/core/src/components/common/atoms/TextItems';
import validatorMethods from '@tcp/core/src/utils/formValidation/validatorMethods';
import SMSTapToJoin from '@tcp/core/src/components/common/molecules/SMSTapToJoin';
import { getDeviceTier } from '@tcp/web/src/utils/device-tiering';
import { generateSessionId, feRegionCookieVal } from '@tcp/core/src/utils/cookie.util';
import { getAPIConfig, isClient } from '@tcp/core/src/utils/utils';
import { reduxForm } from 'redux-form';
import {
  getLocator,
  getViewportInfo,
  isGymboree,
  getBrandInCaps,
  getCountryName,
} from '@tcp/core/src/utils';
import { getPageGenerationDate } from '@tcp/core/src/utils/utils.web.js';
import {
  SNJ_SECONDARY_FILL_WHITE,
  FOOTER_CANDIDATE_A_COL_SIZE,
  FOOTER_CANDIDATE_A_REFER_FRIEND_COL_SIZE,
  SHOW_REFER_FRIEND,
} from '@tcp/core/src/constants/brandSpecific.constants';
import Grid from '@tcp/core/src/components/common/molecules/Grid';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { formatPhoneNumber } from '@tcp/core/src/utils/formValidation/phoneNumber';
import { SHOW_SMS_SIGN_UP } from '@tcp/core/src/constants/brandCountry.constants';

import {
  GLOBAL_EMAIL_SIGN_UP_LABELS,
  GlobalEmailSignUpLabels,
} from '@tcp/core/src/utils/labels/globalEmailSignUp.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import DownloadAppPromo from '@tcp/web/src/components/common/molecules/DownloadAppPromo';
import SocialMediaLinks from '../SocialMediaLinks';

import {
  GLOBAL_REFER_FRIEND,
  GlobalReferAFriend,
  GlobalFooterDefault,
} from '../../labels/Footer.labels';

/* TODO move to component itself */
import style from '../../Footer.style';

import FooterTopSignUpForm from '../FooterTopSignUpForm';

const emailSignupFieldName = 'signup';
const emailSignupSecondBrand = 'isEmailOptInSecondBrand';
const FooterTopEmailSignUpForm = reduxForm({
  form: 'FooterTopEmailSignUpForm', // a unique identifier for this form
  initialValues: {
    [emailSignupFieldName]: '',
    [emailSignupSecondBrand]: false,
  },
})(FooterTopSignUpForm);

const smsSignupFieldName = 'footerTopSmsSignup';
const textSignupSecondBrand = 'isTextOptInSecondBrand';
const FooterTopSmsSignUpForm = reduxForm({
  form: 'FooterTopSmsSignUpForm', // a unique identifier for this form
  initialValues: {
    [smsSignupFieldName]: '',
    [textSignupSecondBrand]: false,
  },
})(FooterTopSignUpForm);

class FooterTopCandidateA extends React.PureComponent {
  emailSignUpLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_EMAIL_SIGN_UP_LABELS,
    GlobalEmailSignUpLabels
  );

  offerZone = getLabelFromCopyOrFromTranslation(
    'global.footerDefault.lbl_footerDefault_offerzone',
    GlobalFooterDefault
  );

  referAFriendLabels = getLabelFromCopyOrFromTranslation(GLOBAL_REFER_FRIEND, GlobalReferAFriend);

  defaultAgeGateVal = getDynamicLabelValues('dynamic.global_d.lbl_default_age_gate');

  constructor(props) {
    super(props);
    this.state = {
      emailDob: '',
      emailDobIsValid: false,
      emailDobError: '',
      smsDob: '',
      smsDobIsValid: false,
      smsDobError: '',
      referFriendDob: '',
      referFriendDobIsValid: false,
      referFriendDobError: '',
      hasMounted: false,
    };
  }

  componentDidMount() {
    const { updateExpandedState, isFooterRedesignEnabled } = this.props;
    if (isFooterRedesignEnabled) {
      updateExpandedState({ offerZoneState: true });
    }
    this.setState({ hasMounted: true });
  }

  getColSize = (device, brandInCaps) => {
    if (device === 'medium') return FOOTER_CANDIDATE_A_COL_SIZE[brandInCaps].MEDIUM;
    return null;
  };

  getIsMobile = () => {
    const { hasMounted } = this.state;
    const { isMobile } = !hasMounted ? { isMobile: false } : getViewportInfo();
    return isMobile;
  };

  toggleAccordion = () => {
    const { updateExpandedState, offerZoneState } = this.props;
    updateExpandedState({ offerZoneState: !offerZoneState });
  };

  checkForDOBValidation = (value, emailDob) => {
    const errorAgeGateText = renderLabel(
      this.emailSignUpLabels.lbl_err_age_gate,
      'lbl_err_age_gate'
    );
    const errorDOBRequiredText = renderLabel(
      this.emailSignUpLabels.lbl_err_dob_required,
      'lbl_err_dob_required'
    );
    const yearOfBirth = value.split('-')[0];
    if (yearOfBirth[0] !== '0') {
      const isValidDoB = validatorMethods.age18plus(this.defaultAgeGateVal, emailDob);
      if (value && isValidDoB) {
        this.setState({ emailDobIsValid: true, emailDobError: '' });
      } else if (value) {
        this.setState({
          emailDobError: errorAgeGateText,
          emailDobIsValid: false,
        });
      } else {
        this.setState({
          emailDobError: errorDOBRequiredText,
          emailDobIsValid: false,
        });
      }
    }
  };

  checkForSMSValidation = (value, smsDob) => {
    const errorAgeGateText = renderLabel(
      this.emailSignUpLabels.lbl_err_age_gate,
      'lbl_err_age_gate'
    );
    const errorDOBRequiredText = renderLabel(
      this.emailSignUpLabels.lbl_err_dob_required,
      'lbl_err_dob_required'
    );
    const yearOfBirth = value.split('-')[0];
    if (yearOfBirth[0] !== '0') {
      const isValidDoB = validatorMethods.age18plus(this.defaultAgeGateVal, smsDob);
      if (value && isValidDoB) {
        this.setState({ smsDobIsValid: true, smsDobError: '' });
      } else if (value) {
        this.setState({
          smsDobError: errorAgeGateText,
          smsDobIsValid: false,
        });
      } else {
        this.setState({
          smsDobError: errorDOBRequiredText,
          smsDobIsValid: false,
        });
      }
    }
  };

  renderEmailSignupForm = () => {
    const {
      emailSignup,
      validateSignupEmail,
      submitEmailSubscription,
      emailSubscription,
      openEmailSignUpModal,
      isNavigationFooter,
      isFooterRedesignEnabled,
    } = this.props;

    const RenderTopEmailSignUpForm = () => (
      <FooterTopEmailSignUpForm
        validateForm={validateSignupEmail}
        onFormSubmit={submitEmailSubscription}
        subscription={emailSubscription}
        openSuccessModal={openEmailSignUpModal}
        dataLocators={{
          submitButton: 'email_submit_btn',
          inputField: 'enter_email_text_field',
          errorDataLocator: 'email_error_message',
          checkBox_gym: 'check_box_gym_opt_in',
          checkBox_tcp: 'check_box_tcp_opt_in',
        }}
        fieldName={emailSignupFieldName}
        secondFieldName={emailSignupSecondBrand}
        isNavigationFooter={isNavigationFooter}
        isFooterRedesignEnabled={isFooterRedesignEnabled}
      />
    );

    const EmailSignUpSection = ({ colSize, className }) => {
      return (
        <Col colSize={colSize} className={className} ignoreGutter={{ small: true }}>
          <BodyCopy
            component="h2"
            fontWeight="black"
            fontSize="fs15"
            className="heading_text email-sign-up"
            dataLocator="email_promo_text"
          >
            <TextItems
              textItems={emailSignup.textItems}
              isFooterRedesignEnabled={isFooterRedesignEnabled}
              customClass="email_sign_up_helper_text"
            />
          </BodyCopy>
          {RenderTopEmailSignUpForm()}
          {emailSignup && emailSignup.richText && emailSignup.richText.text ? (
            <RichText richTextHtml={emailSignup.richText.text} />
          ) : null}
          <div>
            <div className="divider hide-in-medium-up" />
          </div>
        </Col>
      );
    };
    if (isFooterRedesignEnabled) {
      return EmailSignUpSection({
        colSize: {
          large: 12,
          medium: isNavigationFooter ? 8 : 3,
          small: isNavigationFooter ? 6 : 3,
        },
      });
    }
    return EmailSignUpSection({
      colSize: {
        large: 4,
        medium: 4,
        small: 6,
      },
      className: 'col-md-half-width',
    });
  };

  getSmsInput = (smsDob) => {
    return {
      value: smsDob,
      onChange: (e) => {
        this.setState({ smsDob: e.target.value });
        this.checkForSMSValidation(e.target.value, e.target.value);
      },
      onBlur: (e) => {
        this.checkForSMSValidation(e.target.value, smsDob);
      },
    };
  };

  renderReferFriend = (referFriendDob) => {
    return {
      value: referFriendDob,
      onChange: (e) => {
        this.setState({ referFriendDob: e.target.value });
        this.checkForDOBVal(e.target.value, e.target.value);
      },
      onBlur: (e) => {
        this.checkForDOBVal(e.target.value, referFriendDob);
      },
    };
  };

  checkForDOBVal = (value, referFriendDob) => {
    const errorDOBRequiredText = renderLabel(
      this.emailSignUpLabels.lbl_err_dob_required,
      'lbl_err_dob_required'
    );
    const errorAgeGateReferFriendText = renderLabel(
      this.emailSignUpLabels.lbl_err_age_gate_refer_friend,
      'lbl_err_age_gate_refer_friend'
    );
    const yearOfBirth = value.split('-')[0];
    if (yearOfBirth[0] !== '0') {
      const isValidDoB = validatorMethods.age18plus(this.defaultAgeGateVal, referFriendDob);
      if (value && isValidDoB) {
        this.setState({ referFriendDobIsValid: true, referFriendDobError: '' });
      } else if (value) {
        this.setState({
          referFriendDobError: errorAgeGateReferFriendText,
          referFriendDobIsValid: false,
        });
      } else {
        this.setState({
          referFriendDobError: errorDOBRequiredText,
          referFriendDobIsValid: false,
        });
      }
    }
  };

  getReferFriendBlock = () => {
    const { referAFriend, isNavigationFooter, isReferFriendDisabled, isFooterRedesignEnabled } =
      this.props;

    return isReferFriendDisabled ? (
      <Col
        className="refer_a_friend_spacer"
        colSize={{
          large: 12,
          medium: 12,
          small: 12,
        }}
        ignoreGutter={{
          small: true,
        }}
      />
    ) : (
      <>
        <Col
          className="col-md-half-width refer-a-friend-alignment"
          colSize={{
            large: 7.1,
            medium: 4,
            small: isFooterRedesignEnabled ? 6 : 7,
          }}
          ignoreGutter={{
            small: true,
          }}
        >
          <BodyCopy
            component="h2"
            fontWeight="black"
            fontSize="fs15"
            className="heading_text refer-a-friend"
          >
            <TextItems
              textItems={referAFriend.textItems}
              isFooterRedesignEnabled={isFooterRedesignEnabled}
              customClass="email_sign_up_helper_text"
            />
          </BodyCopy>
        </Col>
        <Col
          colSize={{
            large: 4.9,
            medium: 4,
            small: 6,
          }}
          ignoreGutter={{
            small: false,
          }}
          className="candidate_a_inline_container_button col-md-half-width"
        >
          <ClickTracker
            as={Button}
            id={
              isNavigationFooter && !isFooterRedesignEnabled
                ? 'extole_zone_global_navigation_footer'
                : 'extole_zone_global_footer'
            }
            buttonVariation="variable-width"
            data-locator={getLocator('refer_friend')}
            className="refer_a_friend_button"
            fill={SNJ_SECONDARY_FILL_WHITE[`${getBrandInCaps()}`]}
            clickData={{
              customEvents: ['event80'],
              pageShortName: 'content:referafriend  confirmation',
              pageName: 'content:email confirmation',
            }}
          >
            {isFooterRedesignEnabled ? (
              <span className="new-cls">
                {renderLabel(this.referAFriendLabels.text, 'LBL REFER A FRIEND').toLowerCase()}
              </span>
            ) : (
              renderLabel(this.referAFriendLabels.text, 'LBL REFER A FRIEND')
            )}
          </ClickTracker>
        </Col>
      </>
    );
  };

  renderAccordionHeader() {
    const { offerZoneState } = this.props;
    return (
      <Row className="offer-zone" onClick={this.toggleAccordion}>
        {renderLabel(this.offerZone, 'lbl_footerDefault_offerzone')}
        {!offerZoneState ? <span className="closed" /> : <span className="open" />}
      </Row>
    );
  }

  renderSmsSignUpSection(showSmsSignup, isMobile, isFooterRedesignEnabled) {
    const {
      smsSignup,
      validateSignupSmsPhoneNumber,
      submitSmsSubscription,
      smsSubscription,
      openSmsSignUpModal,
      isNavigationFooter,
    } = this.props;
    const RenderSmsSignUpForm = () => (
      <FooterTopSmsSignUpForm
        fieldName={smsSignupFieldName}
        fieldProps={{ normalize: formatPhoneNumber }}
        validateForm={validateSignupSmsPhoneNumber}
        onFormSubmit={submitSmsSubscription}
        subscription={smsSubscription}
        openSuccessModal={openSmsSignUpModal}
        dataLocators={{
          submitButton: 'sms_submit_btn',
          inputField: 'sms_field',
          errorDataLocator: 'sms_error_message',
          checkBox_gym: 'sms_gym_opt_in',
          checkBox_tcp: 'sms_tcp_opt_in',
        }}
        secondFieldName={textSignupSecondBrand}
        isNavigationFooter={isNavigationFooter}
        isFooterRedesignEnabled={isFooterRedesignEnabled}
      />
    );

    if (!showSmsSignup) return null;

    return (
      <Col
        className="col-md-half-width"
        colSize={{ large: 4, medium: 4, small: isNavigationFooter ? 6 : 12 }}
      >
        {isMobile ? (
          <SMSTapToJoin
            smsFromPage="footer"
            isGym={isGymboree}
            isFooterRedesignEnabled={isFooterRedesignEnabled}
          />
        ) : (
          <>
            <BodyCopy
              component="h2"
              fontWeight="black"
              fontSize="fs15"
              className="heading_text sms_sign_up"
            >
              <TextItems
                textItems={smsSignup.textItems}
                isFooterRedesignEnabled={isFooterRedesignEnabled}
                customClass="email_sign_up_helper_text"
              />
            </BodyCopy>
            {RenderSmsSignUpForm()}
          </>
        )}
        {smsSignup && smsSignup.richText && smsSignup.richText.text ? (
          <RichText richTextHtml={smsSignup.richText.text} />
        ) : null}
      </Col>
    );
  }

  renderSmsSignupSectionOld = ({
    isNavigationFooter,
    showSmsSignup,
    isFooterRedesignEnabled,
    isMobile,
    smsSignup,
    RenderSmsSignUpForm,
  }) => {
    if (!isNavigationFooter && showSmsSignup) {
      return (
        <Col
          className="col-md-half-width"
          colSize={{
            large: isFooterRedesignEnabled ? 12 : 4,
            medium: 4,
            small: 6,
          }}
          ignoreGutter={{
            small: true,
          }}
        >
          {isMobile ? (
            <SMSTapToJoin smsFromPage="footer" isGym={isGymboree} />
          ) : (
            <>
              <BodyCopy
                component="h2"
                fontWeight="black"
                fontSize="fs15"
                className="heading_text sms_sign_up"
                dataLocator="sms_promo_text"
              >
                <TextItems
                  textItems={smsSignup.textItems}
                  customClass="email_sign_up_helper_text"
                  isFooterRedesignEnabled={isFooterRedesignEnabled}
                />
              </BodyCopy>
              {RenderSmsSignUpForm()}
            </>
          )}

          {smsSignup && smsSignup.richText && smsSignup.richText.text ? (
            <RichText richTextHtml={smsSignup.richText.text} />
          ) : null}
        </Col>
      );
    }
    return null;
  };

  renderReferFriendSection(showReferFriend, referFriendBlock) {
    const { isNavigationFooter, isReferFriendDisabled } = this.props;
    if (!showReferFriend) return null;

    return (
      <>
        <Col
          className="col-md-half-width refer-a-friend-new"
          colSize={{ large: 4, medium: 4, small: isNavigationFooter ? 6 : 12 }}
        >
          {referFriendBlock}
        </Col>
        <div
          className={`divider ${
            isReferFriendDisabled ? 'hide-in-medium-down hide-in-medium-up' : 'hide-in-medium-up'
          }`}
        />
      </>
    );
  }

  renderAppDownloadSection() {
    const { isNavigationFooter } = this.props;
    return (
      <Col colSize={{ large: 0, medium: 0, small: isNavigationFooter ? 6.8 : 12 }}>
        <DownloadAppPromo isFooter={!isNavigationFooter} />
      </Col>
    );
  }

  renderReferFriendDivider = ({
    isNavigationFooter,

    brandInCaps,
    isReferFriendDisabled,
  }) => {
    if (!isNavigationFooter && SHOW_REFER_FRIEND[brandInCaps]) {
      return (
        <div
          className={`divider ${
            isReferFriendDisabled ? 'hide-in-medium-down hide-in-medium-up' : 'hide-in-medium-up'
          }`}
        />
      );
    }
    return null;
  };

  renderBuildDetails = () => {
    const buildVersion = getAPIConfig().BUILD_NUMBER;
    const getReferenceId = generateSessionId(false);
    const feRegion = feRegionCookieVal();
    const { hasMounted } = this.state;
    return (
      <BodyCopy className="reference-id">
        {hasMounted && isClient() ? `${getReferenceId} | ${getPageGenerationDate()}` : ''}
        {buildVersion ? ` | ${buildVersion}` : ''}
        {` | ${getDeviceTier()} | ${feRegion}`}
      </BodyCopy>
    );
  };

  getRowClassName = (isFooterRedesignEnabled) => {
    return isFooterRedesignEnabled ? 'new-candA-cls' : '';
  };

  // eslint-disable-next-line complexity
  render() {
    const {
      smsSignup,
      links,
      validateSignupSmsPhoneNumber,
      submitSmsSubscription,
      smsSubscription,
      openSmsSignUpModal,
      isNavigationFooter,
      isReferFriendDisabled,
      isFooterRedesignEnabled,
      isDesktop,
      offerZoneState,
    } = this.props;
    const isMobile = this.getIsMobile();
    const brandInCaps = getBrandInCaps();
    // const otherBrand = getOtherBrand();
    const countryName = getCountryName();
    const showSmsSignup = SHOW_SMS_SIGN_UP[brandInCaps][countryName];
    const referFriendBlock = this.getReferFriendBlock();
    const showReferFriend = SHOW_REFER_FRIEND[brandInCaps];
    const RenderSmsSignUpForm = () => (
      <FooterTopSmsSignUpForm
        fieldName={smsSignupFieldName}
        fieldProps={{
          normalize: formatPhoneNumber,
        }}
        validateForm={validateSignupSmsPhoneNumber}
        onFormSubmit={submitSmsSubscription}
        subscription={smsSubscription}
        openSuccessModal={openSmsSignUpModal}
        dataLocators={{
          submitButton: 'sms_submit_btn',
          inputField: 'sms_field',
          errorDataLocator: 'sms_error_message',
          checkBox_gym: 'sms_gym_opt_in',
          checkBox_tcp: 'sms_tcp_opt_in',
        }}
        secondFieldName={textSignupSecondBrand}
        isNavigationFooter={isNavigationFooter}
        isFooterRedesignEnabled={isFooterRedesignEnabled}
      />
    );
    if (isFooterRedesignEnabled && !isDesktop) {
      return (
        <Grid className="footer_top_candidate_a content-wrapper new-top-cand">
          {this.renderAccordionHeader()}
          {offerZoneState && (
            <Row className={`${isFooterRedesignEnabled ? 'new-candA-cls' : ''}`}>
              {this.renderEmailSignupForm()}
              {this.renderSmsSignUpSection(
                showSmsSignup,
                isMobile,
                isGymboree,
                isFooterRedesignEnabled
              )}
              {this.renderReferFriendSection(showReferFriend, referFriendBlock)}
              {this.renderAppDownloadSection()}
            </Row>
          )}
        </Grid>
      );
    }

    return (
      <Grid className="footer_top_candidate_a content-wrapper">
        <Row className={this.getRowClassName(isFooterRedesignEnabled)}>
          {isFooterRedesignEnabled && (
            <div className="offer-zone">
              {renderLabel(this.offerZone, 'lbl_footerDefault_offerzone')}
            </div>
          )}
          {/* ------------ Email Sign Up starts here ----------------- */}

          {!isNavigationFooter && this.renderEmailSignupForm()}

          {/* ---------- Email Signup ends here ---------- */}

          {/* ---------- SMS Sign Up starts here ---------- */}
          {this.renderSmsSignupSectionOld({
            isNavigationFooter,
            showSmsSignup,
            isFooterRedesignEnabled,
            isMobile,
            smsSignup,
            RenderSmsSignUpForm,
          })}

          {!isNavigationFooter && <div className="divider hide-in-large-up" />}
          {/* ---------- SMS Signup ends here ------------ */}

          {/* ---------- Refer a friend start here-------- */}

          {!isNavigationFooter && (
            <Col
              className="refer_a_friend_desktop col-md-half-width"
              colSize={{
                large: isFooterRedesignEnabled ? 12 : 4,
                medium: FOOTER_CANDIDATE_A_REFER_FRIEND_COL_SIZE[brandInCaps].MEDIUM,
                small: 6,
              }}
              ignoreGutter={{
                small: true,
              }}
            >
              <Grid>
                {SHOW_REFER_FRIEND[brandInCaps] && (
                  <>
                    <Row fullBleed className="flex-align-center">
                      {referFriendBlock}
                    </Row>
                    {!isReferFriendDisabled && <div className="divider hide-in-medium-down" />}
                  </>
                )}
                <Row fullBleed className="hide-in-medium-down">
                  <Col
                    className=""
                    colSize={{
                      large: 12,
                      medium: 12,
                      small: 12,
                    }}
                    ignoreGutter={{
                      small: true,
                    }}
                  >
                    {SHOW_REFER_FRIEND[brandInCaps] && (
                      <div className="divider hide-in-medium-up" />
                    )}

                    {!isFooterRedesignEnabled && (
                      <SocialMediaLinks
                        links={links}
                        className="footer_top_candidate_a_social_links"
                      />
                    )}
                  </Col>
                </Row>
              </Grid>
            </Col>
          )}
          {/* ---------- Refer a friend ends here-------- */}

          {this.renderReferFriendDivider({
            isNavigationFooter,
            brandInCaps,
            isReferFriendDisabled,
          })}

          {/* ---------- DownloadAppPromo starts here-------- */}

          <Col
            className="app-promo-new-cls"
            colSize={{
              large: 0,
              medium: 0,
              small: 12,
            }}
            ignoreGutter={{
              small: true,
            }}
          >
            <DownloadAppPromo isFooter={!isNavigationFooter} />
          </Col>

          <Col
            className="hide-in-large-up refer_a_frient_last_colm col-md-half-width"
            colSize={{
              large: 0,
              medium: this.getColSize('medium', brandInCaps),
              small: 12,
            }}
            ignoreGutter={{
              small: true,
            }}
          >
            <SocialMediaLinks links={links} className="social-media-links" />
          </Col>
          {isFooterRedesignEnabled && (
            <Col
              colSize={{
                large: 12,
                medium: 0,
                small: 0,
              }}
            >
              {this.renderBuildDetails()}
            </Col>
          )}
        </Row>
      </Grid>
    );
  }
}

FooterTopCandidateA.propTypes = {
  emailSignup: shape({
    richText: { text: string },
    textItems: arrayOf({}),
  }),
  smsSignup: shape({
    richText: { text: string },
    textItems: arrayOf({}),
  }),
  links: shape([]),
  referAFriend: shape({}),
  validateSignupEmail: func,
  validateSignupSmsPhoneNumber: func,
  submitEmailSubscription: func,
  submitSmsSubscription: func,
  openEmailSignUpModal: func,
  openSmsSignUpModal: func,
  emailSubscription: shape({}),
  smsSubscription: shape({}),
  isNavigationFooter: bool,
  isReferFriendDisabled: bool,
};

FooterTopCandidateA.defaultProps = {
  emailSignup: {
    text: '',
    title: '',
  },
  smsSignup: {
    text: '',
    title: '',
  },
  referAFriend: {
    title: '',
    text: '',
  },
  validateSignupEmail: () => Promise.resolve(),
  validateSignupSmsPhoneNumber: () => Promise.resolve(),
  submitEmailSubscription: () => {},
  submitSmsSubscription: () => {},
  openEmailSignUpModal: () => {},
  openSmsSignUpModal: () => {},
  emailSubscription: {},
  smsSubscription: {},
  isNavigationFooter: false,
  isReferFriendDisabled: false,
};

export default withStyles(FooterTopCandidateA, style);

export { FooterTopCandidateA as FooterTopCandidateAVanilla };
